import { format } from "date-fns";
import { useEffect, useState } from "react";
import { bookingsStatusColorCode } from "../../utils/statusColor";
import useReservationForm from "../../hooks/useReservationForm";


type Props = {
  currentPage: number;
  reservation: any;
};

export default function Summary({
  currentPage,
  reservation
}: Props) {
  const { setShowPopup }: any = useReservationForm();
  const [statusBg, setStatusBg] = useState<string>("");
  const [statusTextColor, setStatusTextColor] = useState<string>("");


  useEffect(() => {
    let color = {
      colorBg: "#000000",
      colorText: "#000000"
    };

    color = bookingsStatusColorCode?.find((color: any) => color?.label === reservation?.status.trim()?.toLowerCase()) || {
      colorBg: "#000000",
      colorText: "#000000"
    };

    setStatusBg(color.colorBg);
    setStatusTextColor(color.colorText);
  }, [reservation]);


  return (
    <>
      <div className={`w-full bg-transparent p-2 flex flex-col gap-1.5 rounded-lg shadow-sm border mt-4 border-[#E4E7EC]`}>
        <div className={`flex justify-between items-center py-4 border-b border-[#E4E7EC]`}>
          <span className={`text-sm font-bold text-[#1D2939]`}>Summary</span>

          <span className={`inline-flex text-xs px-[10px] py-[2px] rounded-xl font-semibold ${statusBg} ${statusTextColor} border border-[#E4E7EC]`}>
            {reservation?.status}
          </span>

        </div>

        <div className="flex flex-col gap-1.5 py-2">
          <div className="flex flex-col justify-between items-start mb-4">
            <span className={`text-xs font-medium break-all w-full text-left text-black-rgba`}>Branch</span>
            <span className={`text-xs font-medium break-all w-full text-left text-[#1D2939]`}>{reservation?.branchName}</span>
          </div>

          {
            reservation?.pickupDate && (
              <div className="flex flex-col justify-between items-start">
                <span className={`text-xs font-medium break-all w-full text-left text-black-rgba`}>Pickup Date

                  {currentPage <= 1 && (
                    <span
                      className={`material-symbols-outlined ml-1 text-[14px] cursor-pointer font-light text-[#0000ff]`}
                      onClick={() => setShowPopup(true)}
                    >
                      edit
                    </span>
                  )}
                </span>

                <span className={`text-xs font-medium break-all w-full text-left text-[#1D2939]`}>
                  {
                    format(
                      new Date(reservation?.pickupDate),
                      "EEEE, MMMM dd, yyyy @ KK:mm a"
                    )
                  }
                </span>
              </div>
            )

          }

          <div className="flex flex-col justify-between items-start mb-4">
            <span className={`text-xs font-medium break-all w-full text-left text-black-rgba`}>Pickup Location</span>
            <span className={`text-xs font-medium break-all w-full text-left text-[#1D2939]`}>{reservation?.pickupLocationName}</span>
          </div>

          {

            reservation?.returnDate && (
              <div className="flex flex-col justify-between items-start">
                <span className={`text-xs font-medium break-all w-full text-left text-black-rgba`}>Return Date
                  {currentPage <= 1 && (
                    <span
                      className={`material-symbols-outlined ml-1 text-[14px] cursor-pointer font-light text-[#0000ff]`}
                      onClick={() => setShowPopup(true)}
                    >
                      edit
                    </span>
                  )}
                </span>

                <span className={`text-xs font-medium break-all w-full text-left text-[#1D2939]`}>
                  {
                    format(
                      new Date(reservation?.returnDate),
                      "EEEE, MMMM dd, yyyy @ KK:mm a"
                    )
                  }
                </span>
              </div>
            )
          }

          <div className="flex flex-col justify-between items-start mb-4">
            <span className={`text-xs font-medium break-all w-full text-left text-black-rgba`}>Return Location</span>
            <span className={`text-xs font-medium break-all w-full text-left text-[#1D2939]`}>{reservation?.returnLocationName}</span>
          </div>

          {
            currentPage !== 1 && (
              <div className="flex flex-col mb-4">
                <span className={`text-xs font-medium break-all text-left text-black-rgba`}>Vehicle Class</span>
                {

                  <span className={`text-xs font-medium break-all w-full text-left text-[#1D2939]`}>{reservation?.vehicleClassLabel}</span>
                }
              </div>
            )
          }

          <div className="flex justify-between gap-x-[0.25rem]">
            {
              currentPage !== 1 && (
                <div className="flex-1 flex flex-col justify-between items-start">
                  <span className={`text-xs font-medium break-all flex-1 text-left text-black-rgba`}>Included Distance</span>
                  <span className={`text-xs font-medium break-all flex-1 text-left text-[#1D2939]`}>{`${reservation?.includedMiles} ${reservation?.includedMiles > 1 ? "miles" : "mile"}`}</span>
                </div>
              )
            }
          </div>
        </div>

        {
          currentPage !== 1 && (
            <>
              <hr className={`w-full bg-[#E4E7EC]`} />
              <div className={`pt-2`}>
                <span className={`text-sm font-bold text-[#1D2939]`}>Price Details</span>
              </div>

              <div className="flex flex-col gap-1.5">
                {
                  reservation?.totalMonths !== 0 && (
                    <div className="flex justify-between items-start w-full">
                      <span className={`text-xs font-medium break-all flex-1 text-left text-[#1D2939]`}>{reservation?.totalMonths}x Months</span>
                      <span className={`text-xs font-medium break-all flex-1 text-right text-[#1D2939]`}> ${reservation?.monthlyRate?.toFixed(2)}</span>
                      <span className={`text-xs font-medium break-all flex-1 text-right text-[#1D2939]`}>${(reservation?.totalMonths * reservation?.monthlyRate)?.toFixed(2)}</span>
                    </div>
                  )
                }

                {
                  reservation?.totalWeeks !== 0 && (
                    <div className="flex justify-between items-start w-full">
                      <span className={`text-xs font-medium break-all flex-1 text-left text-[#1D2939]`}>{reservation?.totalWeeks}x Weeks</span>
                      <span className={`text-xs font-medium break-all flex-1 text-right text-[#1D2939]`}>${reservation?.weeklyRate?.toFixed(2)}</span>
                      <span className={`text-xs font-medium break-all flex-1 text-right text-[#1D2939]`}>${(reservation?.totalWeeks * reservation?.weeklyRate)?.toFixed(2)}</span>
                    </div>
                  )
                }

                {
                  reservation?.totalDays !== 0 && (
                    <div className="flex justify-between items-start w-full">
                      <span className={`text-xs font-medium break-all flex-1 text-left text-[#1D2939]`}>{reservation?.totalDays}x Days</span>
                      <span className={`text-xs font-medium break-all flex-1 text-right text-[#1D2939]`}>${reservation?.dailyRate?.toFixed(2)}</span>
                      <span className={`text-xs font-medium break-all flex-1 text-right text-[#1D2939]`}>${(reservation?.totalDays * reservation?.dailyRate)?.toFixed(2)}</span>
                    </div>
                  )
                }

                {
                  reservation?.totalHours !== 0 && (
                    <div className="flex justify-between items-start w-full">
                      <span className={`text-xs font-medium break-all flex-1 text-left text-[#1D2939]`}>{reservation?.totalHours}x Hours</span>
                      <span className={`text-xs font-medium break-all flex-1  text-right text-[#1D2939]`}>${reservation?.hourlyRate?.toFixed(2)}</span>
                      <span className={`text-xs font-medium break-all flex-1 text-right text-[#1D2939]`}>${(reservation?.totalHours * reservation?.hourlyRate)?.toFixed(2)}</span>
                    </div>
                  )
                }

                <hr className={`w-full bg-[#E4E7EC]`} />             

                {
                  reservation?.additionalCategoryDto
                    ?.map((item: any, j: number) => {
                      return (
                        <div key={j}>
                          <span className={`text-sm font-bold text-[#1D2939]`}>{item?.categoryName}</span>

                          {
                            item?.additionalChargesDto?.map((value: any, i: number) => {
                              return (
                                <div key={i} className="flex justify-between items-center mb-2">
                                  <span className={`text-xs font-medium break-all flex-1 text-left text-black-rgba`}>{value?.name} {value?.quantity > 1 ? value?.quantity + "x " : ''}:</span>
                                  <span className={`text-xs font-medium break-all w-[30%] text-right text-[#1D2939]`}>${(value?.quantity * value?.basePrice)?.toFixed(2)}</span>
                                </div>
                              )

                            })
                          }
                        </div>
                      )
                    })
                }


                {
                  (
                    reservation?.mandatoryAdditionalChargesAmount > 0
                    || reservation?.locationFeePercentage > 0
                    || reservation?.taxPercentage > 0
                    || reservation?.governmentTaxPercentage > 0
                  )
                  && (
                    <div>
                      <span className={`text-sm font-bold text-[#1D2939]`}>Miscellaneous</span>

                      {
                        reservation?.mandatoryAdditionalChargesAmount > 0 &&
                        (
                          <div className="flex justify-between items-center">
                            <span className={`text-xs font-medium break-all flex-1 text-left text-black-rgba`}>{reservation?.mandatoryAdditionalChargesName}:</span>
                            <span className={`text-xs font-medium break-all w-[30%] text-right text-[#1D2939]`}>${parseFloat(reservation?.mandatoryAdditionalChargesAmount)?.toFixed(2)}</span>
                          </div>
                        )
                      }

                      {
                        reservation?.locationFeePercentage > 0 &&
                        (
                          <div className="flex justify-between items-center">
                            <span className={`text-xs font-medium break-all flex-1 text-left text-black-rgba`}>{`${reservation?.locationFeeName} (${reservation?.locationFeePercentage}%)`}:</span>
                            <span className={`text-xs font-medium break-all w-[30%] text-right text-[#1D2939]`}>${parseFloat(reservation?.locationFeeAmount)?.toFixed(2)}</span>
                          </div>
                        )
                      }

                      {
                        reservation?.taxPercentage > 0 &&
                        (
                          <div className="flex justify-between items-center">
                            <span className={`text-xs font-medium break-all flex-1 text-left text-black-rgba`}>{`${reservation?.taxName} (${reservation?.taxPercentage}%)`}:</span>
                            <span className={`text-xs font-medium break-all w-[30%] text-right text-[#1D2939]`}>${parseFloat(reservation?.taxAmount)?.toFixed(2)}</span>
                          </div>
                        )
                      }

                      {
                        reservation?.governmentTaxPercentage > 0 &&
                        (
                          <div className="flex justify-between items-center">
                            <span className={`text-xs font-medium break-all flex-1 text-left text-black-rgba`}>{`${reservation?.governmentTaxName} (${reservation?.governmentTaxPercentage}%)`}:</span>
                            <span className={`text-xs font-medium break-all w-[30%] text-right text-[#1D2939]`}>${parseFloat(reservation?.governmentTaxAmount)?.toFixed(2)}</span>
                          </div>
                        )
                      }
                    </div>
                  )
                }
              </div>

              <hr className={`w-full !mt-2 bg-[#E4E7EC]`} />

              <div className={`flex justify-between items-center py-2`}>
                <span className={`text-sm font-bold text-black-rgba`}>Total</span>
                <span className={`text-sm font-bold text-[#1D2939]`}> ${reservation?.totalPrices?.toFixed(2)}</span>
              </div>

              {
                (reservation?.status?.trim()?.toLocaleLowerCase() === 'open' || reservation?.status?.trim()?.toLocaleLowerCase() === 'quotes') && (
                  <>
                    <hr className={`w-full bg-[#E4E7EC]`} />

                    <div className={`flex justify-between items-center py-4`}>
                      <span className={`text-sm font-bold text-black-rgba`}>Security Deposit</span>
                      <span className={`text-sm font-bold text-red-500`}>${reservation?.securityDepositAmount ? reservation?.securityDepositAmount?.toFixed(2) : 0.00}</span>
                    </div>
                  </>
                )
              }

              {
                currentPage !== 1 &&
                currentPage !== 2 &&
                (
                  <>
                    <hr className={`w-full bg-[#E4E7EC]`} />

                    <div className={`flex justify-between items-center py-2`}>
                      <span className={`text-sm font-bold text-black-rgba`}> Outstanding Balance</span>
                      <span className={`text-sm font-bold text-[#1D2939]`}>${reservation?.outstandingBalance?.toFixed(2) ?? 0.00}</span>
                    </div>
                  </>
                )
              }
            </>
          )
        }
      </div>
    </>
  );
}